import { axios } from '@/plugins/axios';
import { useStore } from '@/store';
import { DOCUMENT_MUTATION } from '@/store/mutations/mutationTypes';
import { download } from '@/utils/fileDownload';
import { endPoints, Params } from '../types/api';
import {
  buildOfficialDocument,
  OfficialDocument,
} from '../types/entities/OfficialDocument';
import { useNotification } from './useNotification';

export const useOfficialDocument = ({
  organization_type_id,
}: {
  organization_type_id: number;
}) => {
  const { getters, commit } = useStore();
  const officialDocument: OfficialDocument = getters.officialDocument;
  const { showNotification } = useNotification();

  const getOfficialDocument = () => {
    return axios
      .get(endPoints.getOfficialDocument.endPoint, {
        params: { organization_type_id },
      })
      .then((res) => {
        const resultDocument = buildOfficialDocument(res.data.items);

        return resultDocument;
      });
  };

  // VuexのactionsはPromiseを返さないのでaxiosを使用する
  const saveOfficialDocument = (payload: Params<'saveOfficialDocument'>) => {
    return axios
      .post(endPoints.saveOfficialDocument.endPoint, payload, {
        headers: {
          'content-type': 'multipart/form-data',
        },
      })
      .then((res) => {
        showNotification({
          isShow: true,
          message: '周知文書を登録しました',
          type: 'success',
        });
        commit(DOCUMENT_MUTATION.SAVE_OFFICIAL_DOCUMENT, res.data);
      });
  };

  const downloadOfficialDocumentTemplate = async () => {
    return axios
      .get(endPoints.downloadOfficialDocumentTemplate.endPoint, {
        params: {
          organization_type_id,
        },
        responseType: 'blob',
      })
      .then(download);
  };

  return {
    officialDocument,
    saveOfficialDocument,
    getOfficialDocument,
    downloadOfficialDocumentTemplate,
  };
};
